// extracted by mini-css-extract-plugin
module.exports = {"metadata":"index_metadata_1zYHq","app-type-list":"index_app-type-list_3zmrZ"};